import { devtoolsExchange } from "@urql/devtools"
import {
  cacheExchange,
  createClient as createUrqlClient,
  fetchExchange,
  ssrExchange,
  subscriptionExchange,
} from "@urql/next"
import { createClient as createWSClient } from "graphql-ws"
import type { ErrorHandler } from "../types"
import { apqExchange } from "./exchange/apq-exchange"
import { errorExchange } from "./exchange/errorExchange"
import { reconnectExchange } from "./exchange/reconnectExchange"
import { requestPolicyExchange } from "./exchange/request-policy"
import { tabVisibilityExchange } from "./exchange/tabVisibilityExchange"
import { GRAPHQL_API_URL, GRAPHQL_HEADERS, GRAPHQL_WS_URL } from "./shared"

export const createClient = ({
  errorHandler,
  apiUrl,
  wsUrl,
}: {
  errorHandler?: ErrorHandler
  apiUrl?: string
  wsUrl?: string
}) => {
  const ssr = ssrExchange({ isClient: typeof window !== "undefined" })
  const wsClient = createWSClient({ url: wsUrl ?? GRAPHQL_WS_URL })

  const urlClient = createUrqlClient({
    url: apiUrl ?? GRAPHQL_API_URL,
    suspense: true,
    fetchSubscriptions: false,
    preferGetMethod: false,
    fetchOptions: {
      headers: GRAPHQL_HEADERS,
      credentials: "include",
    },
    exchanges: [
      reconnectExchange(),
      tabVisibilityExchange(),
      ...(errorHandler ? [errorExchange(errorHandler)] : []),
      devtoolsExchange,
      requestPolicyExchange(),
      cacheExchange,
      ssr,
      apqExchange,
      fetchExchange,
      subscriptionExchange({
        forwardSubscription(request) {
          const input = { ...request, query: request.query || "" }
          return {
            subscribe(sink) {
              const unsubscribe = wsClient.subscribe(input, sink)
              return { unsubscribe }
            },
          }
        },
      }),
    ],
  })

  return [urlClient, ssr] as const
}
